import React from 'react';
import styles from './TransportDocuments.module.scss';
import RoundedButton from '../RoundedButton/RoundedButton';
import useTransportAttachments from './api/queris/useTransportAttachments';
import { Icon, Popover, Tooltip } from 'antd';
import ContentDocsTransport from './components/ContentDocsTransport/ContentDocsTransport';

const TransportDocuments = ({ transportId, zIndex = 1000, ...props }) => {
  const { data = [], isFetching } = useTransportAttachments(transportId, {
    enabled: !!transportId,
  });

  const hasDocs = !!data?.length && !isFetching;

  return (
    <Popover
      title="Документы ТС"
      trigger="click"
      placement="right"
      content={
        <ContentDocsTransport
          transportId={transportId}
          data={data}
        />
      }
      zIndex={zIndex}
    >
      <Tooltip
        placement="topLeft"
        title={hasDocs ? 'Документы ТС' : 'Добавить документы'}
        zIndex={zIndex}
      >
        <RoundedButton
          text={
            <Icon
              type={isFetching ? 'loading' : 'paper-clip'}
              style={{
                color: hasDocs ? '#3378F9' : '#888',
                fontSize: '18px',
              }}
            />
          }
          type="link"
          className={styles.customBtn}
          {...props}
        />
      </Tooltip>
    </Popover>
  );
};

export default TransportDocuments;
